define('GameDayCore/GDModel/ValueObjects/Hits/Hit',['require','exports','module','../ValueObjectFactory'],function(require, exports, module) {
	var VO = require('../ValueObjectFactory');

	VO.create(Hit);

	function Hit($data) {
		var vo = VO.ensureVO(this, Hit),
			data = $data;

		vo.des = data.des;
		vo.x = data.x;
		vo.y = data.y;
		vo.batter = data.batter;
		vo.pitcher = data.pitcher;
		vo.type = data.type;
		vo.team = data.team;
		vo.inning = data.inning;
	}

	return Hit;
});
